(function () {
  var brindeVariantIds = new Set();
  var brindeProductIds = new Set();
  var addInFlight = false;
  var optimisticBrindeInCart = false;
  var purgeInFlight = false;
  var lastKnownState = {
    hasBrinde: false,
    hasPaidProduct: false,
    brindeQuantity: 0,
  };

  var I18N_DEFAULTS = {
    empty_cart: 'This gift item can only be added when there are other products in your cart.',
    already_in_cart: 'This gift item is already in your cart.',
  };

  function getI18n() {
    var i18n = window.madesaBrindeI18n || {};
    return {
      empty_cart: i18n.empty_cart || I18N_DEFAULTS.empty_cart,
      already_in_cart: i18n.already_in_cart || I18N_DEFAULTS.already_in_cart,
    };
  }

  function registerVariantId(variantId) {
    if (variantId != null && variantId !== '') {
      brindeVariantIds.add(String(variantId));
    }
  }

  function registerProductId(productId) {
    if (productId != null && productId !== '') {
      brindeProductIds.add(String(productId));
    }
  }

  function parseConfig() {
    var el = document.getElementById('madesa-brinde-config');
    if (!el) return;

    try {
      var config = JSON.parse(el.textContent || '{}');
      (config.variantIds || []).forEach(registerVariantId);
      (config.productIds || []).forEach(registerProductId);
      lastKnownState.hasBrinde = !!config.cartHasBrinde;
      lastKnownState.hasPaidProduct = !!config.cartHasPaidProduct;
      optimisticBrindeInCart = lastKnownState.hasBrinde;
    } catch (e) {
      console.warn('[madesa-brinde] Config inválida:', e);
    }
  }

  function registerFromDom() {
    document.querySelectorAll('product-form-component[data-is-brinde="true"]').forEach(function (formEl) {
      registerProductId(formEl.getAttribute('data-product-id'));
      formEl.querySelectorAll('[name="id"]').forEach(function (input) {
        registerVariantId(input.value);
      });
    });
  }

  function isBrindeVariant(variantId) {
    return brindeVariantIds.has(String(variantId));
  }

  function isBrindeProduct(productId) {
    return brindeProductIds.has(String(productId));
  }

  function isBrindeCartItem(item) {
    if (!item) return false;
    return (
      isBrindeVariant(item.variant_id) ||
      isBrindeProduct(item.product_id) ||
      (item.properties && item.properties._brinde === 'true')
    );
  }

  function fetchCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
      return res.json();
    });
  }

  function analyzeCart(cart) {
    var hasBrinde = false;
    var brindeQuantity = 0;
    var hasPaidProduct = false;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (isBrindeCartItem(item)) {
        hasBrinde = true;
        brindeQuantity += Number(item.quantity) || 0;
        registerVariantId(item.variant_id);
        registerProductId(item.product_id);
      } else {
        hasPaidProduct = true;
      }
    });

    lastKnownState = {
      hasBrinde: hasBrinde,
      hasPaidProduct: hasPaidProduct,
      brindeQuantity: brindeQuantity,
    };
    optimisticBrindeInCart = hasBrinde;
    return lastKnownState;
  }

  function getBlockReason(state) {
    if (!state.hasPaidProduct) return 'empty_cart';
    if (state.hasBrinde || state.brindeQuantity >= 1) return 'already_in_cart';
    return null;
  }

  function getCurrentBlockReason() {
    if (addInFlight) return 'already_in_cart';
    if (optimisticBrindeInCart || lastKnownState.hasBrinde) return 'already_in_cart';
    if (!lastKnownState.hasPaidProduct) return 'empty_cart';
    return null;
  }

  function showError(reason) {
    var i18n = getI18n();
    var message = reason === 'empty_cart' ? i18n.empty_cart : i18n.already_in_cart;
    document.dispatchEvent(
      new CustomEvent('toast:show', {
        detail: { message: message, type: 'error' },
      })
    );
  }

  function setAddToCartButtonsDisabled(formEl, disabled) {
    if (!formEl) return;
    formEl.querySelectorAll('add-to-cart-component button, button.add-to-cart-button').forEach(function (btn) {
      if (btn.closest('madesa-buy-now')) return;
      btn.disabled = disabled;
      btn.classList.toggle('madesa-brinde-btn--blocked', disabled);
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function setBuyNowDisabled(formEl, disabled) {
    if (!formEl) return;
    var buyNow = formEl.closest('.buy-buttons-block');
    if (!buyNow) {
      buyNow = formEl.parentElement;
    }
    if (!buyNow) return;
    buyNow.querySelectorAll('madesa-buy-now button').forEach(function (btn) {
      if (btn.classList.contains('madesa-buy-now-btn--busy')) return;
      btn.disabled = disabled;
      btn.classList.toggle('madesa-brinde-btn--blocked', disabled);
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function syncProductForm(formEl) {
    if (!(formEl instanceof HTMLElement) || formEl.dataset.isBrinde !== 'true') return;

    var reason = getCurrentBlockReason();
    var blocked = !!reason;

    setAddToCartButtonsDisabled(formEl, blocked);
    setBuyNowDisabled(formEl, blocked);

    if (reason) {
      formEl.setAttribute('data-brinde-block-reason', reason);
    } else {
      formEl.removeAttribute('data-brinde-block-reason');
    }
  }

  function syncAllBrindeForms() {
    document.querySelectorAll('product-form-component[data-is-brinde="true"]').forEach(syncProductForm);
  }

  function isAddLocked() {
    return addInFlight || optimisticBrindeInCart;
  }

  /**
   * Mutex síncrono: impede cliques rápidos antes de qualquer await.
   */
  function tryBeginBrindeAdd() {
    if (addInFlight || optimisticBrindeInCart) {
      return false;
    }
    addInFlight = true;
    optimisticBrindeInCart = true;
    syncAllBrindeForms();
    return true;
  }

  function confirmBrindeAdd(options) {
    var productId = options && options.productId;
    var variantId = options && options.variantId;

    return fetchCart()
      .then(function (cart) {
        var state = analyzeCart(cart);
        var reason = getBlockReason(state);
        if (reason) {
          releaseBrindeAddFailed();
          return { ok: false, reason: reason };
        }

        registerProductId(productId);
        registerVariantId(variantId);
        syncAllBrindeForms();
        return { ok: true, state: state };
      })
      .catch(function (error) {
        releaseBrindeAddFailed();
        throw error;
      });
  }

  function releaseBrindeAddFailed() {
    addInFlight = false;
    optimisticBrindeInCart = lastKnownState.hasBrinde;
    syncAllBrindeForms();
  }

  function releaseBrindeAddSuccess(productId, variantId) {
    addInFlight = false;
    registerProductId(productId);
    registerVariantId(variantId);
    optimisticBrindeInCart = true;
    lastKnownState.hasBrinde = true;
    syncAllBrindeForms();
  }

  function validateBrindeAdd(options) {
    if (!tryBeginBrindeAdd()) {
      return Promise.resolve({ ok: false, reason: 'already_in_cart' });
    }
    return confirmBrindeAdd(options);
  }

  function buildCartLineChange(cart, lineKey, newQty) {
    var items = (cart && cart.items ? cart.items : []).map(function (item) {
      return {
        key: item.key,
        quantity: item.quantity,
        variant_id: item.variant_id,
        product_id: item.product_id,
        isBrinde: isBrindeCartItem(item),
      };
    });

    return buildCartLineChangeFromItems(items, lineKey, newQty);
  }

  function buildCartLineChangeFromDom(lineKey, newQty) {
    var managers = document.querySelectorAll('cart-item-manager[data-variant-key]');
    if (!managers.length) {
      return { mode: 'change', id: lineKey, quantity: Number(newQty) };
    }

    var items = [];
    managers.forEach(function (manager) {
      items.push({
        key: manager.getAttribute('data-variant-key'),
        quantity: parseInt(manager.getAttribute('data-quantity') || '0', 10) || 0,
        variant_id: manager.getAttribute('data-variant-id'),
        product_id: manager.getAttribute('data-product-id'),
        isBrinde: manager.getAttribute('data-is-brinde') === 'true',
      });
    });

    return buildCartLineChangeFromItems(items, lineKey, newQty);
  }

  function buildCartLineChangeFromItems(items, lineKey, newQty) {
    var updates = {};
    var wouldHavePaid = false;
    var brindeKeys = [];
    var nextQty = Number(newQty);

    items.forEach(function (item) {
      if (!item.key) return;

      var qty = item.key === lineKey ? nextQty : Number(item.quantity);

      if (item.key === lineKey) {
        updates[item.key] = qty;
      }

      if (qty <= 0) {
        return;
      }

      var isBrinde =
        item.isBrinde ||
        isBrindeVariant(item.variant_id) ||
        isBrindeProduct(item.product_id);

      if (isBrinde) {
        brindeKeys.push(item.key);
      } else {
        wouldHavePaid = true;
      }
    });

    if (!wouldHavePaid && brindeKeys.length) {
      if (!Object.prototype.hasOwnProperty.call(updates, lineKey)) {
        updates[lineKey] = nextQty;
      }
      brindeKeys.forEach(function (key) {
        updates[key] = 0;
      });
      return { mode: 'update', updates: updates, removedOrphanBrindes: true };
    }

    return { mode: 'change', id: lineKey, quantity: nextQty };
  }

  function applyCartMutationResponse(cart) {
    if (!cart) return;
    analyzeCart(cart);
    if (!lastKnownState.hasBrinde) {
      optimisticBrindeInCart = false;
    }
    addInFlight = false;
    syncAllBrindeForms();
  }

  function removeOrphanBrindes(cart) {
    var state = analyzeCart(cart);

    if (!state.hasBrinde || state.hasPaidProduct || purgeInFlight) {
      return Promise.resolve(false);
    }

    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (isBrindeCartItem(item)) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return Promise.resolve(false);
    }

    purgeInFlight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (updatedCart) {
        applyCartMutationResponse(updatedCart);

        if (typeof updateCartCounters === 'function' && updatedCart.item_count != null) {
          updateCartCounters(updatedCart.item_count);
        }

        if (typeof window.refreshCart === 'function') {
          window.refreshCart(null, { openMinicart: false });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

        return true;
      })
      .catch(function (error) {
        console.warn('[madesa-brinde] Falha ao remover brinde órfão:', error);
        return false;
      })
      .finally(function () {
        purgeInFlight = false;
      });
  }

  function refreshFromCart() {
    return fetchCart()
      .then(function (cart) {
        addInFlight = false;
        return removeOrphanBrindes(cart).then(function (removed) {
          if (!removed) {
            analyzeCart(cart);
            syncAllBrindeForms();
          }
          return removed;
        });
      })
      .catch(function (error) {
        console.warn('[madesa-brinde] Falha ao atualizar estado:', error);
      });
  }

  window.MadesaBrinde = {
    tryBeginBrindeAdd: tryBeginBrindeAdd,
    confirmBrindeAdd: confirmBrindeAdd,
    validateBrindeAdd: validateBrindeAdd,
    releaseBrindeAddFailed: releaseBrindeAddFailed,
    releaseBrindeAddSuccess: releaseBrindeAddSuccess,
    refreshFromCart: refreshFromCart,
    syncAllBrindeForms: syncAllBrindeForms,
    syncProductForm: syncProductForm,
    isBrindeProduct: isBrindeProduct,
    isBrindeVariant: isBrindeVariant,
    isBrindeCartItem: isBrindeCartItem,
    getBlockReason: getBlockReason,
    analyzeCart: analyzeCart,
    showError: showError,
    isAddLocked: isAddLocked,
    fetchCart: fetchCart,
    buildCartLineChange: buildCartLineChange,
    buildCartLineChangeFromDom: buildCartLineChangeFromDom,
    applyCartMutationResponse: applyCartMutationResponse,
    removeOrphanBrindes: removeOrphanBrindes,
  };

  parseConfig();
  registerFromDom();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      registerFromDom();
      refreshFromCart();
    });
  } else {
    registerFromDom();
    refreshFromCart();
  }

  document.addEventListener('cart:updated', function () {
    refreshFromCart();
  });
  document.addEventListener('cart:refresh', function () {
    refreshFromCart();
  });
})();
